// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__B7fjN","title":"ClientInsurance_title__3W8Pl","itemText":"ClientInsurance_itemText__Glgoy"};